<script>
import { assign, isEmpty } from 'lodash'
import { warning, success } from '@/utils/alert'

export default {
  name: 'ChangePassword',
  data: () => ({
    credentials: {
      current_password: null,
      password: null,
      confirmation: null
    }
  }),
  methods: {
    doChange () {
      const credentials = assign({}, this.credentials)
      if (isEmpty(credentials.current_password)) {
        warning('Favor informar a senha atual.')
      }
      if (isEmpty(credentials.password) && !isEmpty(credentials.current_password)) {
        warning('Favor informar a nova senha.')
      }

      if (credentials.password !== credentials.confirmation) {
        return warning('As senhas não conferem!')
      }
      delete credentials.confirmation

      this.$resource.update('', credentials)
        .then(({data}) => {
          this.credentials = {
            current_password: null,
            password: null,
            confirmation: null
          }
          success('Sua senha foi alterada com sucesso.')
        })
    }
  },
  resourcePath: '/v1/settings/users/me/password'
}
</script>

<template lang="pug">
  #menu-password.collapse
    .col-xs-12.col-sm-12.p-top-10
      f-password(placeholder="Senha atual", v-model="credentials.current_password")
    .col-xs-12.col-sm-12.p-top-10
      f-password(placeholder="Nova senha", v-model="credentials.password")

    .col-xs-12.col-sm-12.p-top-10
      f-password(placeholder="Confirme a nova senha", v-model="credentials.confirmation")

    button.pull-right.btn.save(@click.prevent="doChange()", type="button")
      span.icon 
      |  Salvar Alterações
    .clearfix
</template>



// WEBPACK FOOTER //
// src/layout/headers/changePassword.vue